
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTemperatureWater as ObiTemperatureWaterElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-temperature-water.js';
 
 
 

 
 export const ObiTemperatureWater = createComponent({
   react: React,
   tagName: 'obi-temperature-water',
   elementClass: ObiTemperatureWaterElement,
   events: {
     
   }
  });
 
 